var LOG_LEVEL;
(function (LOG_LEVEL) {
    /** Не логгировать */
    LOG_LEVEL["OFF"] = "OFF";
    /** Логи и ошибки */
    LOG_LEVEL["LOG"] = "LOG";
    /** Только ошибки */
    LOG_LEVEL["ERROR"] = "ERROR";
})(LOG_LEVEL || (LOG_LEVEL = {}));
const DEBUG_COOKIE = new RegExp('debug=([A-Z]+)');
/**
 * Logger в debug режиме
 * Уровень логирования выставляется кукой `debug`
 * Уровни логирования
 * ```
 *    'OFF' - Не логгировать
 *    'LOG' - Логи и ошибки
 *    'ERROR' - Только ошибки
 * ```
 * @example
 *     Logger.getInstance().error(e);
 */
export default class Logger {
    constructor() {
        this.isEnable = typeof document !== 'undefined' && DEBUG_COOKIE.test(document.cookie);
        this.logLevel = typeof document !== 'undefined' && (DEBUG_COOKIE.exec(document.cookie) || [])[1] || LOG_LEVEL.OFF;
    }
    log(data) {
        if (this.logLevel === LOG_LEVEL.LOG) {
            this.print(data, Logger.STYLE.LOG);
        }
    }
    error(e) {
        if (this.logLevel === LOG_LEVEL.OFF) {
            return;
        }
        this.print(e.toString(), Logger.STYLE.ERROR);
    }
    print(data, style) {
        if (!this.isEnable) {
            return;
        }
        console.info(`${Logger.TAG} ${data}`, style);
    }
    static getInstance() {
        if (this.instance) {
            return this.instance;
        }
        this.instance = new Logger();
        return this.instance;
    }
}
Logger.TAG = '%c 🐞 [logger]';
Logger.STYLE = {
    LOG: 'background: #222; color: #bada55; padding:3px;',
    ERROR: 'background: #222; color: red; padding:3px;',
};



// WEBPACK FOOTER //
// ./src/web-frontend-core/devtools/logger.js